import cn from 'bem-cn';

import { Icon, Stack } from '../../../../UI';

import { ChallengeRequirementProps } from './ChallengeRequirement.types';
import './ChallengeRequirement.scss';

const b = cn('challenge-requirement');

export const ChallengeRequirement = (props: ChallengeRequirementProps) => {
    const { text } = props;

    return (
        <Stack direction="row" spacing={12} className={b()} alignItems="center">
            <Stack className={b('icon-container')} justifyContent="center" alignItems="center">
                <Icon className={b('icon')} name="checkboxTick" size={12} />
            </Stack>
            <p className={b('text')}>{text}</p>
        </Stack>
    );
};
